import { render, staticRenderFns } from "./userListComp.vue?vue&type=template&id=164d5bf2&scoped=true"
import script from "./userListComp.vue?vue&type=script&lang=js"
export * from "./userListComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164d5bf2",
  null
  
)

export default component.exports